import { type ReactNode } from 'react';
import { useRequiredVideoCtx } from './required-video-context';
import { RequiredVideoYTPlayer } from './required-video-yt';
import { RequiredVideoLoomPlayer } from './required-video-loom';

const PLACEHOLDER_CLS =
  'flex aspect-video w-full items-center justify-center rounded-lg border border-white/[0.08] bg-white/[0.05] text-text-tertiary backdrop-blur-xl';

function Stub({ label }: { label: string }): ReactNode {
  return <div className={PLACEHOLDER_CLS}>{label}</div>;
}

export function RequiredVideoPlayer(): ReactNode {
  const { config, loading, error, state } = useRequiredVideoCtx();
  if (loading) return <Stub label="Cargando…" />;
  if (error || !config) return <Stub label="Video no disponible" />;
  if (config.video_id === 'PLACEHOLDER')
    return <Stub label="Video pendiente" />;
  if (config.provider === 'youtube') {
    return <RequiredVideoYTPlayer videoId={config.video_id} state={state} />;
  }
  return <RequiredVideoLoomPlayer videoId={config.video_id} state={state} />;
}
